<template lang="pug">
  main#main.statically-privacy
    b-container(fluid)
      wc-breadcrumb(icon='fal fa-info-circle')
      section.l-section
        .l-section-h
          component(:is='locale')
</template>

<script>
import WcBreadcrumb from '@components/shared/WcBreadcrumb'

export default {
  name: 'statically-privacy',
  components: {
    WcBreadcrumb,
  },
  computed: {
    locale() {
      /* Reactivity computed by call actual locale. */
      this.$i18n.locale
      return () =>
        import(`@views/container/statically/privacy/${this.$wc.shared.locale}`).catch(() =>
          import(`@views/container/statically/privacy/${this.$wc.conf.base.default_locale}`)
        )
    },
  },
}
</script>
